import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ReportsMonitoringContainer from '../../containers/reports/Monitoring';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { sortStationTable, doesStationMatchFilter } from '../../libs/utility';

//- material-ui
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
//import IconButton from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import DownloadIcon from '@material-ui/icons/CloudDownload';

import { getSharedStyles } from '../../themes';
import InitialLoading from '../../components/InitialLoading';
import FMPCheckbox from '../../components/pureForm/FMPCheckbox';

export const isLocalhost = Boolean(window.location.hostname === 'localhost');

const MONTHS_BACK = 12; // We want to see the past year
const formatNum = (num) => {
	const formatter = new Intl.NumberFormat('en-US', {
		//style: 'currency',
		//currency: 'USD',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
	const formatted = formatter.format(num);
	return parseFloat(formatted.replace(/,/g, ''));
};

const styles = (theme) => ({
	...getSharedStyles(theme),
	/*
	paper: {
		height: 600,
		width: '100%',
		overflowX: 'auto',
		//minHeight : 500,
		//marginBottom: 20,
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
		[theme.breakpoints.up('sm')]: {
			padding: '20px 20px 20px 20px',
		},
	},
	*/
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	reportInfo: {
		textAlign: 'left',
		padding: '10px 0px',
		fontSize: '18px',
		fontWeight: '300',
	},
	warning: {
		color: '#FFC107',
		width: 16,
		height: 16,
		paddingRight: 3,
	},
	error: {
		color: '#e53935',
		width: 20,
		height: 20,
		paddingRight: 3,
	},
	question: {
		color: '#91b5b9',
		width: 20,
		height: 20,
		paddingRight: 3,
	},
	info: {
		color: '#2196F3',
		width: 20,
		height: 20,
		paddingRight: 3,
	},
	upDownIcon: {
		marginTop: -15,
		bottom: -6,
		width: 28,
		height: 22,
		position: 'relative',
	},
	diffUp: {
		fontWeight: 900,
		color: '#4CAF50',
	},
	diffDown: {
		fontWeight: 900,
		color: '#FF500F',
	},
	label: {},
	subLabel: {
		fontWeight: 200,
		color: '#999',
		fontSize: 13,
	},
	value: {
		fontWeight: 600,
	},
	stats: {
		padding: '10px 10px 20px 10px',
		borderBottom: '1px solid #ddd',
		marginBottom: 10,
	},
	reportedDateTime: {
		fontSize: '13px',
		fontWeight: 200,
		color: '#555',
		whiteSpace: 'nowrap',
	},
	exportButton: {
		borderRadius: '100px',
		padding: '8px 10px',
		fontSize: 12,
	},
	icon: {
		paddingRight: 5,
	},
});

/*
const productTypeToDisplay = {
	e85: 'E85',
	//bioDiesel : 'Bio-Diesel'
};
*/

function getMonthKey(date) {
	return `${date.month()}-${date.year()}`;
}

class NewStationDashboard extends Component {
	constructor(props) {
		super(props);

		this.state = {
			order: 'asc',
			orderBy: 'number',
			search: '',
			showGm: false,
		};
		this.handleRowClick = this.handleRowClick.bind(this);
		this.handleRequestSort = this.handleRequestSort.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
	}

	componentDidMount() {
		if (!this.props.tankMonthlySales) {
			this.props.getNewStationsSalesAndRetail({
				params: {
					monthsBack: MONTHS_BACK,
				},
			});
		}
	}

	handleSearch(event) {
		this.setState({ search: event.target.value });
	}

	handleRowClick(stationId, tankNumber) {
		this.props.history.push(`/reports/stationVolume/${stationId}/${tankNumber}`);
	}

	handleRequestSort(property) {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	}
	toggleGm = () => {
		this.setState({ showGm: !this.state.showGm });
	};

	renderDownloadButton = () => {
		const { classes, accessToken } = this.props;

		const params = {
			accessToken,
			monthsBack: MONTHS_BACK,
			downloadCsv: true,
		};

		const request = {
			method: 'report.newStations.getSalesAndRetail',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}

		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<a
				href={downloadUrl}
				style={{ textDecoration: 'none', paddingRight: 5 }}
				target="_blank"
				rel="noreferrer noopener"
			>
				<Button
					className={classes.exportButton}
					variant="contained"
					color="primary"
					style={{ marginLeft: 10 }}
				>
					<DownloadIcon className={classes.icon} />
					Export To CSV
				</Button>
			</a>
		);
	};

	render() {
		const { classes, tankMonthlySales, stationMap, gasFormulaMap, authUser } = this.props;

		if (!tankMonthlySales || !authUser || !stationMap) {
			return <InitialLoading />;
		}

		const { order, orderBy, search, showGm } = this.state;
		//const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		const tankKey = (t) => {
			return `${t.stationId}_${t.tankNumber}`;
		};

		//const mon = moment().format('MMM');
		const monthlySalesColumns = [
			//{ id: 'count', numeric: false, label: '#', padding: 'checkbox' },
			{ id: 'number', numeric: false, label: 'Station' },

			{
				id: 'daysOpen',
				numeric: true,
				label: (
					<div style={{ textAlign: 'center' }}>
						Days
						<br />
						Open
					</div>
				),
			},

			{ id: 'recentPrice', numeric: true, label: 'Recent Pricing' },
			{ id: 'previousPrice', numeric: true, label: 'Previous Pricing' },
			{ id: 'gasFormulaSort', numeric: false, label: 'Formula' },
			{ id: 'freightFullLoad', numeric: false, label: 'Freight' },
			//{ id: 'totalThisMonth', numeric: true, label: `${mon} Total` },
			//{ id: 'productAndTank', numeric: false, label: 'Product / Tank', disablePadding : true },
		];

		const last6Months = [];
		_.range(0, 6).forEach((i) => {
			last6Months.push(moment().subtract(i, 'month'));
		});

		// Get all the days this month to get teh running
		// month total
		const daysThisMonth = [];
		const yesterday = moment().subtract({ days: 1 });
		const startOfMonth = moment().startOf('month');
		const indexMoment = moment(startOfMonth);
		while (indexMoment.isBefore(yesterday)) {
			daysThisMonth.push(moment(indexMoment));
			indexMoment.add(1, 'day');
		}

		last6Months.forEach((date) => {
			const monthDisplay = date.format('MMM');
			const yearDisplay = date.format('YYYY');

			monthlySalesColumns.push({
				id: `month-${getMonthKey(date)}-display`,
				numeric: true,
				disablePadding: true,
				style: { padding: 0 },
				label: (
					<div style={{ textAlign: 'center' }}>
						{monthDisplay}
						<br />
						{yearDisplay}
					</div>
				),
			});
		});

		const now = moment();

		const dailySales = tankMonthlySales.reduce((result, salesRow) => {
			const {
				stationId,
				tankNumber,
				//productType,
				estimatedMargin,
				recentGasBuddy,
				previousGasBuddy,
				monthlySales,
			} = salesRow;

			const station = stationMap[stationId];
			if (doesStationMatchFilter({ search, station }) === false) {
				return result;
			}
			//const productDisplay = productTypeToDisplay[productType];
			const productDisplay = 'E85';
			const {
				number,
				name,
				stationIsNotActive,
				gasFormulaId,
				freightFullLoad,
				openedDate,
			} = station;
			if (stationIsNotActive) {
				return result;
			}

			if (number.match(/^GOV/)) {
				return result;
			}

			if (!showGm && number.match(/^GM/)) {
				return result;
			}

			const daysOpen = now.diff(openedDate, 'days');

			let recentPrice;
			let priceDisplay = '-';

			if (recentGasBuddy) {
				recentPrice = recentGasBuddy.gasBuddyPrice;
				const recentEntry = moment(recentGasBuddy.reportedDateTime).format('M/D h:mm a');

				priceDisplay = (
					<div style={{ textAlign: 'right' }}>
						<div style={{ fontSize: '17px', fontWeight: '500' }}>${recentPrice}</div>
						<div className={classes.reportedDateTime}>{recentEntry}</div>
						<div style={{ whiteSpace: 'nowrap' }}>Est. Margin: {estimatedMargin}</div>
					</div>
				);
			}

			let previousPrice;
			let previousPriceDisplay = '-';

			if (previousGasBuddy) {
				previousPrice = previousGasBuddy.gasBuddyPrice;
				const previousEntry = moment(previousGasBuddy.reportedDateTime).format('M/D h:mm a');

				previousPriceDisplay = (
					<div style={{ textAlign: 'right' }}>
						<div style={{ fontSize: '17px', fontWeight: '500' }}>${previousPrice}</div>
						<div className={classes.reportedDateTime}>{previousEntry}</div>
					</div>
				);
			}

			/*
			if (previousGasBuddy) { 
				const previousPrice = recentGasBuddy.gasBuddyPrice;
				const previousEntry = moment(previousGasBuddy.reportedDateTime).format('M/D h:mm a');

				priceDisplays.push(
					<div style={{ textAlign: 'right' }}>
						<div style={{ fontSize: '17px', fontWeight: '500' }}>${previousPrice}</div>
						<div className={classes.reportedDateTime}>{previousEntry}</div>
						<div style={{ whiteSpace: 'nowrap' }}>Est. Margin: {estimatedMargin}</div>
					</div>
				);
			}*/

			const gasFormula = gasFormulaMap[gasFormulaId] || { display: 'Missing' };
			const gasFormulaDisplay = gasFormula.display;

			let gasFormulaSort = gasFormulaId * 1000;
			const match = gasFormulaDisplay.match(/-?\d+/);
			if (gasFormulaDisplay.match(/New Retail/) && match) {
				gasFormulaSort = parseInt(match[0]);
			}
			const row = _.merge({
				stationId,
				id: stationId,
				number,
				name,
				daysOpen,
				station: (
					<div>
						<div style={{ fontSize: '24px', fontWeight: 700 }}>{number}</div>
						<div>
							<div style={{ whiteSpace: 'nowrap' }}>{name}</div>
							<div style={{ fontSize: 13, color: '#666' }}>
								({productDisplay} / Tank #{tankNumber})
							</div>
						</div>
					</div>
				),
				recentPrice,
				previousPrice,
				priceDisplay,
				previousPriceDisplay,
				gasFormulaSort,
				estimatedMargin,
				freightFullLoad,
				freightDisplay: freightFullLoad,
				gasFormulaDisplay,
				tankNumber,
				rowClick: () => this.handleRowClick(stationId, tankNumber),
			});

			// monthlySales = [{ year, month, dailyVolume }]

			const monthSalesByDateKey = _.keyBy(monthlySales, (sale) => {
				return `${sale.month}-${sale.year}`;
			});

			last6Months.forEach((date) => {
				const dateKey = getMonthKey(date);
				const salesRow = _.get(monthSalesByDateKey, [dateKey], {});
				row[`month-${dateKey}-display`] = _.isNumber(salesRow.dailyAverage)
					? formatNum(salesRow.dailyAverage)
					: '-';
			});

			result.push(row);
			return result;
		}, []);

		const dailySalesRows = sortStationTable({ rows: dailySales, orderBy, order });
		const stationCount = _.keys(_.keyBy(dailySalesRows, tankKey)).length;

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12} md={8}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>New Station Dashboard</span>
								<TextField
									className={classes.formControl}
									value={this.state.search}
									onChange={(event) => this.handleSearch(event)}
									label="Type to search"
									fullWidth
								/>
							</Typography>
						</Grid>
						<Grid
							item
							xs={12}
							md={4}
							style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
						>
							{this.renderDownloadButton()}
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						<div style={{ display: 'flex' }}>
							<div className={classes.reportInfo}>
								Stations With An Open Date In Last {MONTHS_BACK} Months:
								<span style={{ fontWeight: 900 }}> {stationCount} stations</span>
							</div>
							<div style={{ marginLeft: '50px', fontSize: '85%' }}>
								<FMPCheckbox
									path={'showGm'}
									onChange={this.toggleGm}
									value={'showGm'}
									checked={this.state.showGm}
									label={'Show G&M Stations'}
								/>
							</div>
						</div>
						<div style={{ color: '#777', fontSize: '14px' }}>
							Note: An asterisk in front of the total for the month indicates we do not have a
							reported volume for every day of the month.
						</div>

						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={monthlySalesColumns}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{dailySalesRows.map((n) => {
									return (
										<TableRow
											hover
											className={classes.row}
											style={{ backgroundColor: n.isSelected ? '#ef9a9a' : undefined }}
											key={`${n.id}_${n.tankNumber}`}
										>
											<TableCell onClick={n.rowClick}>{n.station}</TableCell>
											<TableCell onClick={n.rowClick} style={{ textAlign: 'right' }}>
												{n.daysOpen}
											</TableCell>
											<TableCell onClick={n.rowClick}>{n.priceDisplay}</TableCell>
											<TableCell onClick={n.rowClick}>{n.previousPriceDisplay}</TableCell>
											<TableCell onClick={n.rowClick}>{n.gasFormulaDisplay}</TableCell>
											<TableCell onClick={n.rowClick}>{n.freightDisplay}</TableCell>

											{last6Months.map((date) => {
												const dateKey = getMonthKey(date);
												return (
													<TableCell
														key={`month-${dateKey}-display`}
														onClick={n.rowClick}
														align="right"
														padding={'none'}
													>
														{n[`month-${dateKey}-display`]}
													</TableCell>
												);
											})}
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

NewStationDashboard.propTypes = {
	classes: PropTypes.object.isRequired,
	getNewStationsSalesAndRetail: PropTypes.func.isRequired,
	tankMonthlySales: PropTypes.array,

	stationMap: PropTypes.object,
	gasFormulaMap: PropTypes.object,
	order: PropTypes.string,
	orderBy: PropTypes.string,

	history: PropTypes.object,
	authUser: PropTypes.object,
	accessToken: PropTypes.string,
};

export default _.flow([withStyles(styles), ReportsMonitoringContainer])(NewStationDashboard);
